import { LocaleState } from "./type";
import { PatientInformationFormState } from "../PatientInformationForm/type";
import { IGenericsLang, ILabelSelect } from "../../services/Language/Types";
import { ApplicationState } from "..";

export const getLanguageCode = (state: LocaleState) => state.lang;

export const getLanguageResourceGeneralStrings = (state: LocaleState): IGenericsLang =>
    state.currentLanguageText && state.currentLanguageText.getGeneralStrings();

export const getLanguageResourceCountryMappedStrings = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getGeneralCountryMappedStrings();

export const getCountriesLanguageResourceSelectOptionsForClinicHealthCards = (state: ApplicationState) => {
    return state.localeText.currentLanguageText.getCountriesSelectionOptions(state.clinicInformation.healthCards.map(p => p.countryCode).distinct());
}

export const getLanguageResourceCountrySelectOptions = (state: LocaleState) => {
    return state.currentLanguageText.getCountriesSelectionOptions();
}

export const getLanguageResourceAllRegionsSelectOptions = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getAllCountryRegionsOptions();

export const getRegionsLanguageResourceSelectOptionsForClinicHealthCards = (state: ApplicationState) => {
    const options: { [countryCode: string]: string[] } = {};
    for (const healthCardInfo of state.clinicInformation.healthCards) {
        const { countryCode, regionCode } = healthCardInfo;
        if (!options[countryCode]) {
            options[countryCode] = [];
        }

        if (!options[countryCode].contains(regionCode)) {
            options[countryCode].push(regionCode)
        }
    }

    return state.localeText.currentLanguageText
        && state.localeText.currentLanguageText.getAllCountryRegionsOptionsForSpecificCountryAndRegions(options);
}

export const getLanguageResourcePrefixOptions = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getPrefixSelectionOptions();

export const getLanguageResourcePatientOverviewStrings = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getPatientOverviewStrings();

export const getLanguageResourceContactPointOptions = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getContactPointSelectionOptions();

export const getLanguageResourcePhoneTypeOptions = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getPhoneSelectionOptions();

export const getLanguageResourceErrorStrings = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getErrorStrings();

export const getLanguageResourceLanguageLitteralStrings = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getLanguageLitteralStrings();

export const getLanguageResourceLanguageSelectionOptions = (state: LocaleState) =>
    state.currentLanguageText && state.currentLanguageText.getLanguageSelectionOptions();

export const getLocaleTextForSnackBarPopup = (state: LocaleState) => {
    if (!state.currentLanguageText) {
        return null;
    }
    const generalText = state.currentLanguageText.getGeneralStrings();
    return {
        message: generalText.messagesInstructions.InactivityMessage,
        dismissText: generalText.labels.DismissButton
    };
};

export const getCountryListOptionsFromPatientInfo = (
    state: LocaleState,
    patientInfo: PatientInformationFormState
): Set<ILabelSelect> => {
    const returnArray = new Set<ILabelSelect>();
    if (!state.currentLanguageText) {
        return returnArray;
    }
    const addresses = patientInfo.patientInformation.addresses;
    const countryOptions = state.currentLanguageText.getCountriesSelectionOptions();
    for (const cntry of countryOptions) {
        for (const addr of addresses) {
            if (addr.country === cntry.value) {
                returnArray.add(cntry);
                break;
            }
        }
    }
    return returnArray;
};

export const getTextLibrary = (state: LocaleState) => state.textLibrary;

export const getTextLibraryForSaga = (state: ApplicationState) => state.localeText.textLibrary;


// WEBPACK FOOTER //
// ./src/store/LanguageLocale/selector.ts